import React from "react";
import "../css/wrapper.css";

const Wrapper = ({ children }) => {
  return (
    <div className="wrapper-background">
      <div className="background-image"></div>
      <div className="content">{children}</div>
    </div>
  );
};

export default Wrapper;
